import { PayloadAction } from "@reduxjs/toolkit";
import { SessionState, SessionStatus } from "types/Session";
import { RequestStatus } from "types";

const setCredentials = (state: any, action: PayloadAction<any>): void => {
  state.credentials = action.payload;
};
const setEmbedToken = (
  state: SessionState,
  action: PayloadAction<any>
): void => {
  state.embedToken = action.payload;
};
const updateSessionStatus = (
  state: SessionState,
  action: PayloadAction<any>
): void => {
  state.status = action.payload;
};

const updateIsAuthenticated = (
  state: SessionState,
  action: PayloadAction<boolean>
): void => {
  state.isAuthenticated = action.payload;
};

const logOut = (state: any): void => {
  state.isAuthenticated = false;
  state.credentials = undefined;
  state.status = SessionStatus.logOut;
};

const confirmSession = (state: SessionState): void => {
  state.isSessionConfirmed = true;
};

const setTwoFAUpdateStatus = (
  state: SessionState,
  action: PayloadAction<RequestStatus>
) => {
  state.twoFAUpdateStatus = action.payload;
};

const setOtpAuthUrl = (
  state: SessionState,
  action: PayloadAction<any>
): void => {
  state.otpAuthUrl = action.payload;
};

const setTwoFactorAuthEnabled = (
  state: SessionState,
  action: PayloadAction<boolean>
) => {
  state.twoFactorAuthEnabled = action.payload;
};

const setTwoFactorValidated = (
  state: SessionState,
  action: PayloadAction<RequestStatus>
) => {
  state.twoFactorValidated = action.payload;
};

const setLoginRequestStatus = (
  state: SessionState,
  action: PayloadAction<RequestStatus>
) => {
  state.loginRequestStatus = action.payload;
};

const reducers = {
  setCredentials,
  confirmSession,
  setTwoFAUpdateStatus,
  updateIsAuthenticated,
  updateSessionStatus,
  logOut,
  setEmbedToken,
  setOtpAuthUrl,
  setTwoFactorAuthEnabled,
  setTwoFactorValidated,
  setLoginRequestStatus,
};

export default reducers;
